// 哔咔漫画翻页体验站 - 首页数据
// 漫画封面统一为暖色调手绘动漫风格插画

export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  tag: string;
  chapter: string;
  update: string;
  views: string;
  favorite: number;
  cover: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "纸间告白",
    author: "鹿屿酱",
    category: "恋爱",
    tag: "心动",
    chapter: "第 132 话",
    update: "今天 09:20",
    views: "1280 万",
    favorite: 98234,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20hand-drawn%20anime%20illustration%20of%20a%20romantic%20manga%20comic%20cover%2C%20two%20school%20teens%20almost%20touching%20hands%2C%20soft%20coral%20pink%20and%20cream%20background%2C%20cherry%20blossom%20petals%20floating%2C%20cozy%20sweet%20atmosphere%2C%20painterly%20art%20style%2C%20gentle%20golden%20lighting%2C%20high%20detail%2C%20no%20text&width=500&height=700&seq=comic-cover-01&orientation=portrait",
  },
  {
    id: 2,
    title: "星海拾梦",
    author: "拾荒少年",
    category: "奇幻",
    tag: "冒险",
    chapter: "第 88 话",
    update: "昨天 21:40",
    views: "956 万",
    favorite: 76109,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20hand-drawn%20anime%20fantasy%20manga%20cover%20with%20a%20young%20boy%20reaching%20for%20glowing%20stars%20and%20floating%20dream%20bubbles%2C%20sunset%20orange%20and%20amber%20sky%2C%20magical%20adventure%20mood%2C%20cream%20warm%20tones%2C%20painterly%20art%20style%2C%20high%20detail%2C%20no%20text&width=500&height=700&seq=comic-cover-02&orientation=portrait",
  },
  {
    id: 3,
    title: "逆光少年",
    author: "乔木",
    category: "校园",
    tag: "青春",
    chapter: "第 210 话",
    update: "08-15 18:10",
    views: "2103 万",
    favorite: 120431,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20hand-drawn%20anime%20school%20manga%20cover%2C%20a%20teenage%20boy%20standing%20under%20golden%20sunlight%20in%20a%20courtyard%2C%20backlight%20glow%20with%20coral%20and%20honey%20tones%2C%20youthful%20energetic%20mood%2C%20soft%20cream%20sky%2C%20painterly%20art%20style%2C%20high%20detail%2C%20no%20text&width=500&height=700&seq=comic-cover-03&orientation=portrait",
  },
  {
    id: 4,
    title: "深渊回响",
    author: "夜航者",
    category: "悬疑",
    tag: "烧脑",
    chapter: "第 64 话",
    update: "08-14 22:30",
    views: "742 万",
    favorite: 50318,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20hand-drawn%20anime%20mystery%20manga%20cover%2C%20a%20silhouette%20figure%20in%20an%20old%20library%20with%20flickering%20candlelight%20and%20scattered%20paper%20sheets%2C%20deep%20amber%20and%20terracotta%20tones%2C%20dark%20moody%20but%20warm%2C%20painterly%20art%20style%2C%20dramatic%20lighting%2C%20high%20detail%2C%20no%20text&width=500&height=700&seq=comic-cover-04&orientation=portrait",
  },
  {
    id: 5,
    title: "热血食堂",
    author: "大厨阿福",
    category: "搞笑",
    tag: "美食",
    chapter: "第 175 话",
    update: "08-13 12:15",
    views: "1634 万",
    favorite: 89320,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20hand-drawn%20anime%20comedy%20manga%20cover%2C%20a%20cheerful%20chef%20with%20steaming%20delicious%20food%20bowls%20and%20sparkling%20effects%2C%20orange%20and%20peach%20tones%2C%20fun%20energetic%20atmosphere%2C%20cream%20warm%20background%2C%20painterly%20art%20style%2C%20high%20detail%2C%20no%20text&width=500&height=700&seq=comic-cover-05&orientation=portrait",
  },
  {
    id: 6,
    title: "机甲黎明",
    author: "铁壳子",
    category: "科幻",
    tag: "燃向",
    chapter: "第 49 话",
    update: "08-12 20:05",
    views: "518 万",
    favorite: 41207,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20hand-drawn%20anime%20sci-fi%20mecha%20manga%20cover%2C%20a%20giant%20robot%20silhouette%20against%20a%20sunset%20orange%20sky%20with%20smoke%20and%20embers%2C%20rust%20and%20amber%20tones%2C%20epic%20action%20mood%2C%20painterly%20art%20style%2C%20dramatic%20warm%20lighting%2C%20high%20detail%2C%20no%20text&width=500&height=700&seq=comic-cover-06&orientation=portrait",
  },
];

export interface SoundItem {
  id: number;
  name: string;
  en: string;
  desc: string;
  duration: string;
  icon: string;
}

export const sounds: SoundItem[] = [
  {
    id: 1,
    name: "清脆翻页",
    en: "Crisp Turn",
    desc: "纸张快速划过空气的爽脆声响，适合节奏紧凑的战斗与悬疑分镜。",
    duration: "0.8s",
    icon: "ri-file-text-line",
  },
  {
    id: 2,
    name: "轻柔翻页",
    en: "Soft Turn",
    desc: "缓慢细腻的纸面摩擦声，把日常与温馨场景翻得更安静。",
    duration: "1.2s",
    icon: "ri-leaf-line",
  },
  {
    id: 3,
    name: "复古书页",
    en: "Old Paper",
    desc: "泛黄纸页的沙沙质感，还原旧书翻阅的岁月味道。",
    duration: "1.0s",
    icon: "ri-book-2-line",
  },
  {
    id: 4,
    name: "动画弹跳",
    en: "Spring Pop",
    desc: "翻页伴随俏皮的弹性音效，让搞笑桥段更带节奏感。",
    duration: "0.9s",
    icon: "ri-bubble-chart-line",
  },
  {
    id: 5,
    name: "点击确认",
    en: "Tap Confirm",
    desc: "轻巧的触点回馈音，适合章节选择与功能按钮。",
    duration: "0.4s",
    icon: "ri-cursor-line",
  },
  {
    id: 6,
    name: "翻页连翻",
    en: "Rapid Flip",
    desc: "多页连续翻动的沙沙声，快速扫读时更有流动感。",
    duration: "1.5s",
    icon: "ri-arrow-left-right-line",
  },
];

export interface Category {
  id: number;
  name: string;
  desc: string;
  count: string;
  icon: string;
}

export const categories: Category[] = [
  { id: 1, name: "热血", desc: "打斗燃向与成长逆袭", count: "3.2 万部", icon: "ri-fire-line" },
  { id: 2, name: "恋爱", desc: "心动日常与甜宠心动", count: "2.8 万部", icon: "ri-heart-3-line" },
  { id: 3, name: "悬疑", desc: "烧脑推理与惊悚反转", count: "1.4 万部", icon: "ri-search-eye-line" },
  { id: 4, name: "奇幻", desc: "异世界与神话冒险", count: "1.9 万部", icon: "ri-star-smile-line" },
  { id: 5, name: "科幻", desc: "机甲、太空与未来想象", count: "9800 部", icon: "ri-rocket-2-line" },
  { id: 6, name: "搞笑", desc: "沙雕日常与轻松解压", count: "2.1 万部", icon: "ri-emotion-happy-line" },
  { id: 7, name: "校园", desc: "青春成长与纯真羁绊", count: "1.7 万部", icon: "ri-graduation-cap-line" },
  { id: 8, name: "日常", desc: "治愈系生活切片", count: "1.2 万部", icon: "ri-sun-line" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "哔咔漫画的翻页音效是真实录制的声音吗？",
    a: "是的。翻页音效专区收录的每一条声音都经过专业拾音录制与后期调校，再叠加轻量算法渲染，确保每一次翻页都能获得接近真实纸质书页的听觉反馈，并且声音会根据翻页速度自适应变化。",
  },
  {
    q: "翻页动画会对手机耗电或卡顿有影响吗？",
    a: "不会。翻页动画基于 GPU 加速与逐帧渲染优化，动画全程不阻塞主线程，即使在高帧率模式下也保持流畅。你还可以在设置中关闭动画、只保留音效，以追求更极致的省电阅读。",
  },
  {
    q: "如何在不同设备上获得一致的翻页体验？",
    a: "哔咔漫画会根据屏幕尺寸自动调整翻页的触控区域、动画幅度与音效音量，无论是竖屏手机还是横屏平板，都能获得自然一致的纸感阅读体验。",
  },
  {
    q: "可以自定义专属的翻页音效与动画吗？",
    a: "可以。你可以在「阅读设置」中自由切换音效风格、调节音量，并选择翻页动画的曲线与方向，甚至可以关闭某一项，组合出专属于你的阅读手感。",
  },
  {
    q: "追更热门漫画时翻页会中断吗？",
    a: "不会。哔咔漫画支持后台预加载与章节缓存，翻页音效与动画在离线状态下同样可用，让你在地铁、通勤途中也能不间断地沉浸追更。",
  },
];

export interface Testimonial {
  id: number;
  name: string;
  role: string;
  text: string;
  avatar: string;
  initial: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "夜风阿澈",
    role: "每日追更用户",
    text: "第一次把翻页音效打开时真的被惊到了，沙沙的纸声特别真实，配合动画就像真的在翻一本纸书，追热血漫都不舍得按快进了。",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20avatar%20of%20a%20smiling%20young%20man%20with%20short%20dark%20hair%20and%20orange%20shirt%2C%20soft%20cream%20background%2C%20friendly%20expression%2C%20minimal%20cartoon%20style%2C%20warm%20coral%20tones%2C%20clean%20and%20cute&width=160&height=160&seq=avatar-01&orientation=squarish",
    initial: "澈",
  },
  {
    id: 2,
    name: "一颗糖球",
    role: "恋爱漫爱好者",
    text: "轻柔翻页的音效太适合恋爱漫了，安静又有氛围感，夜晚躲在被窝里追《纸间告白》真的幸福感拉满。",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20avatar%20of%20a%20happy%20young%20girl%20with%20wavy%20brown%20hair%20and%20peach%20top%2C%20soft%20cream%20background%2C%20sweet%20smile%2C%20minimal%20cartoon%20style%2C%20warm%20amber%20tones%2C%20clean%20and%20cute&width=160&height=160&seq=avatar-02&orientation=squarish",
    initial: "糖",
  },
  {
    id: 3,
    name: "老猫逛漫",
    role: "资深漫迷",
    text: "复古书页的声音一出来就是满满的旧时光味道，悬疑漫配这个音效氛围直接拉满，细节做得很用心。",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20avatar%20of%20a%20friendly%20middle-aged%20man%20with%20glasses%20and%20mustache%2C%20tan%20jacket%2C%20soft%20cream%20background%2C%20gentle%20smile%2C%20minimal%20cartoon%20style%2C%20warm%20terracotta%20tones%2C%20clean%20and%20cute&width=160&height=160&seq=avatar-03&orientation=squarish",
    initial: "猫",
  },
];

export const navLinks = [
  { id: "sound", label: "翻页音效" },
  { id: "flip", label: "翻页动画" },
  { id: "comics", label: "热门漫画" },
  { id: "category", label: "主题分类" },
  { id: "brand", label: "品牌口碑" },
  { id: "faq", label: "常见问题" },
];